import type { IPackage } from '../../../stores/app/types';
import type { SubscriptionPlanEnhanced } from '../../../stores/subscription/types';

export function isSubscriptionPackage(pkg: unknown): pkg is IPackage & { subscriptionData: SubscriptionPlanEnhanced } {
  return (
    typeof pkg === 'object' &&
    pkg !== null &&
    'subscriptionData' in pkg &&
    (pkg as IPackage).subscriptionData !== undefined &&
    (pkg as IPackage).subscriptionData !== null
  );
}
